/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {
    arrayOf, bool, func, number, object, shape, string,
} from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CheckIcon from '@material-ui/icons/Check';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import subscriptionConfig from '../../../../../helpers/common/subscription/subscription-helpers';
import EventDispatcher from '../../../state/reducers/EventDispatcher';

const styles = () => ({
    frequencyWrapper: {
        width: '99%',
        marginRight: '1%',
        '@media screen and (min-width: 1024px)': {
            display: 'flex',
        },
        '@media screen and (min-width: 1440px)': {
            display: 'block',
        },
    },
    frequencyButtonContainer: {
        padding: '8px 10px 8px 22px',
        border: '1px solid #dcdcdc',
        borderRadius: 0,
        display: 'flex',
        justifyContent: 'space-between',
        backgroundColor: '#E8F1ED',
        cursor: 'pointer',
    },
    cancelledStatus: {
        cursor: 'auto',
    },
    frequencyButton: {
        display: 'flex',
        alignItems: 'center',
    },
    checkIcon: {
        height: '22px',
        marginLeft: '17px',
    },
    listContainer: {
        marginTop: '9px',
        boxShadow: '0 3px 3px rgba(47, 47, 47, 0.15)',
        background: '#FFFFFF',
    },
    frequencySelect: {
        backgroundColor: '#E8F1ED',
        display: 'flex',
    },
    frequencyList: {
        cursor: 'pointer',
        padding: '8px 10px 8px 22px',
        '&:hover': {
            backgroundColor: '#E8F1ED',
        },
    },
    frequencyLabel: {
        padding: '8px 0',
        fontWeight: '600',
        '@media screen and (min-width: 1024px)': {
            padding: '16px 0',
        },
    },
    subscriptionContent: {
        marginBottom: 12,
    },
    durationContainer: {
        marginTop: '27px',
        '@media screen and (min-width: 1024px)': {
            width: '50%',
            marginTop: '0',
            paddingLeft: '30px',
        },
        '@media screen and (min-width: 1440px)': {
            paddingLeft: '0',
            width: '100%',
        },
    },
    frequencyContainer: {
        '@media screen and (min-width: 1024px)': {
            width: '50%',
        },
        '@media screen and (min-width: 1440px)': {
            width: '100%',
        },
    },
    dropDownConatiner: {
        '@media screen and (min-width: 1024px)': {
            width: '80%',
        },
        '@media screen and (min-width: 1440px)': {
            width: '100%',
        },
    },
});

const SubscriptionDropDown = ({
    classes,
    isDesktop,
    fieldLabel,
    subscription,
    subscriptionsList,
    setFrequencyValue,
    setDurationValue,
    updateSubFrequency,
    updateSubscriptionList,
    enableEditButton,
}) => {
    const [openFrequencyList, setOpenFrequencyList] = React.useState(false);
    const [openDurationList, setOpenDurationList] = React.useState(false);
    const [subFrequency, setSubFrequency] = React.useState({});
    const [subDuration, setSubDuration] = React.useState({});

    const handleFrequencyDropDown = () => {
        setOpenFrequencyList(!openFrequencyList);
        setOpenDurationList(false);
    };
    // const handleDurationDropDown = () => {
    //     setOpenDurationList(!openDurationList);
    //     setOpenFrequencyList(false);
    // };

    const frequencyDropdownList = Object.keys(subscriptionConfig?.['subscription_interval']).map((item) => {
        const obj = {
            id: Number(item),
            value: subscriptionConfig?.['subscription_interval'][item],
        };
        return obj;
    });
    const durationDropdownList = Object.keys(subscriptionConfig?.['subscription_duration']).map((item) => {
        const obj = {
            id: Number(item),
            value: subscriptionConfig?.['subscription_duration'][item],
        };
        return obj;
    });

    useEffect(() => {
        // set default value
        setSubFrequency(frequencyDropdownList.find((item) => subscription?.['interval'] === item.id));
        setSubDuration(durationDropdownList.find((item) => subscription?.['duration'] === item.id));
    }, [subscriptionsList]);

    const frequencyOptionList = frequencyDropdownList.filter((item) => subscriptionsList?.['interval']?.includes?.(item.id));
    // const durationOptionList = durationDropdownList.filter((item) => subscriptionsList?.['duration']?.includes?.(item.id));

    const handleFrequencyChange = (frequency) => {
        setFrequencyValue(frequency.id);
        setSubFrequency(frequency);
        if (isDesktop) {
            const { ruleId } = subscription;
            const frequencyData = {
                ruleId,
                frequency: frequency.id,
            };
            updateSubFrequency(frequencyData);
            updateSubscriptionList({ ...subscription, interval: frequency.id });
        }
    };

    const handleDurationChange = (duration) => {
        setDurationValue(duration.id);
        setSubDuration(duration);
    };

    const PAY_AS_YOU_GO_ORDER = subscription?.subscriptionType?.toLowerCase() === 'monthonly';
    const disableEditBtn = !enableEditButton(subscription) || PAY_AS_YOU_GO_ORDER;

    return (
        <div className={classes.subscriptionContent}>
            <div className={classes.frequencyWrapper}>
                <div className={classes.frequencyContainer}>
                    <div className={classes.frequencyLabel}>
                        {fieldLabel}
                    </div>
                    <div className={classes.dropDownConatiner}>
                        <div
                            aria-hidden="true"
                            onClick={!disableEditBtn ? handleFrequencyDropDown : undefined}
                            className={`${classes.frequencyButtonContainer} ${disableEditBtn && classes.cancelledStatus}`}
                        >
                            <span className={classes.frequencyButton}>{subFrequency.value} <CheckIcon className={classes.checkIcon} /></span>
                            {!disableEditBtn && (!openFrequencyList ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />)}
                        </div>
                        <div className={classes.listContainer}>
                            {openFrequencyList && frequencyOptionList.map((item) => (
                                <div
                                    key={item.id}
                                    aria-hidden="true"
                                    className={`${classes.frequencyList} ${item.id === subFrequency.id && classes.frequencySelect}`}
                                    onClick={() => handleFrequencyChange(item)}
                                >
                                    {item?.value}
                                    {item.id === subFrequency.id && <CheckIcon className={classes.checkIcon} />}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
                <div className={classes.durationContainer}>
                    <div className={classes.frequencyLabel}>
                        Duration
                    </div>
                    <div className={classes.dropDownConatiner}>
                        <div
                            aria-hidden="true"
                            // onClick={handleDurationDropDown}
                            className={`${classes.frequencyButtonContainer} ${classes.cancelledStatus}`}
                        >
                            <span className={classes.frequencyButton}>{subDuration?.value} <CheckIcon className={classes.checkIcon} /></span>
                            {/* {!openDurationList ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />} */}
                        </div>
                        <div className={classes.listContainer}>
                            {openDurationList && durationDropdownList.map((item) => (
                                <div
                                    key={item.id}
                                    aria-hidden="true"
                                    className={`${classes.frequencyList} ${item.id === subDuration.id && classes.frequencySelect}`}
                                    onClick={() => handleDurationChange(item)}
                                >
                                    {item?.value}
                                    {item.id === subDuration.id && <CheckIcon className={classes.checkIcon} />}
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

SubscriptionDropDown.propTypes = {
    classes: object.isRequired,
    isDesktop: bool,
    subscription: object.isRequired,
    subscriptionsList: shape({
        duration: arrayOf(
            number,
        ),
        type: arrayOf(
            string,
        ),
        interval: arrayOf(
            number,
        ),
    }).isRequired,
    fieldLabel: string,
    setFrequencyValue: func,
    setDurationValue: func,
    updateSubFrequency: func.isRequired,
    updateSubscriptionList: func,
    enableEditButton: func.isRequired,
};

SubscriptionDropDown.defaultProps = {
    fieldLabel: 'Frequency:',
    isDesktop: false,
    updateSubscriptionList: () => {},
    setFrequencyValue: () => {},
    setDurationValue: () => {},
};

const mapDispatchToProps = (dispatch) => ({
    updateSubFrequency: (frequencyData) => dispatch(EventDispatcher.updateSubscriptionFrequency(frequencyData)),
});

export default connect(null, mapDispatchToProps)(withStyles(styles)(SubscriptionDropDown));
